import React from 'react';
import { modules } from '../data/modules';
import { PRODUCT } from '../data/constants';
export function SystemSection() {
  return <section className="bg-leaf-soft py-5 sm:py-7" data-id="element-158" data-mp="3gihoxkzfi0s2">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-159" data-mp="3bimy1hfnlb70">
        <h2 className="text-center text-2xl leading-none text-forest sm:text-4xl" data-id="element-160" data-mp="3bh23hrtc9s95">
          Everything you need.{' '}
          <span className="text-leaf" data-id="element-161" data-mp="36m68cist2ort">One complete plant nutrition visual system.</span>
        </h2>
        <p className="mt-1.5 text-center font-display text-sm font-semibold uppercase tracking-wide text-gold-dark sm:text-lg" data-id="element-162" data-mp="31mjymjc6rqnr">
          6 Professional Visual Reference Modules In One Organized System
        </p>

        <div className="mx-auto mt-3 max-w-4xl rounded-lg border-2 border-forest bg-white p-3 text-center sm:p-5" data-id="element-163" data-mp="2ntkhye0o3qem">
          <p className="font-display text-lg font-extrabold uppercase leading-tight text-forest sm:text-2xl" data-id="element-164" data-mp="2iur6er4xy9h3">
            🌱 {PRODUCT}
          </p>
          <p className="mt-1.5 text-sm leading-snug text-ink sm:text-base" data-id="element-165" data-mp="2dvwjpe3us0rp">
            {PRODUCT} brings nutrient deficiency identification, toxicity and imbalance
            comparisons, soil and pH interpretation, plant tissue analysis, crop-specific
            visual references, and professional field assessment workflows together in one
            complete system.
          </p>
          <p className="mx-auto mt-2 w-fit max-w-full rounded bg-forest px-3 py-1 font-display text-[11px] font-bold uppercase tracking-wide text-white sm:text-base" data-id="element-166" data-mp="z0mul29u5oxs">
            Observe → <span className="text-gold" data-id="element-167" data-mp="1rnr7ruj319kn">Compare</span> → Investigate →{' '}
            <span className="text-gold" data-id="element-168" data-mp="1cs1fxfr7u280">Analyze</span> → Evaluate →{' '}
            <span className="text-gold" data-id="element-169" data-mp="1ctw18v6efwcm">Document</span>
          </p>
        </div>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-170" data-mp="1horyqauenbx4">
          {modules.map(module => <article key={module.title} className="rounded-lg bg-white p-3 shadow-sm sm:p-4" style={{
          borderLeft: `6px solid ${module.color}`
        }} data-id="element-171" data-mp="1eh8k3l83qnb">
              <h3 className="flex items-start gap-1.5 text-sm leading-tight text-forest sm:text-base" data-id="element-172" data-mp="28zxrh6mffqx8">
                <span className="text-leaf" aria-hidden="true" data-id="element-173" data-mp="241e5553x8d4c">
                  ✓
                </span>
                {module.title}
              </h3>
              <p className="mt-1 text-sm leading-snug text-ink" data-id="element-174" data-mp="1u8felhov6ci3">{module.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}